__webpack_require__.p = "https://uat-secure-dev4-helix.bac-assets.com/auth/retrieve/";